module.exports = __webpack_public_path__ + "img/en.219af19a.png";